import getConfig from 'next/config';
import { parse as parseQueryString } from 'querystring';
import { parseCookies } from './cookies';
import { NextPageContext } from 'next';

const DEFAULT_FALLBACK_URL = 'https://www.johnlewis.com/';
const CONTENT_BASE_PATH = 'content-renderer';

const contentURLMapper = (
  rawUrl: string,
  isHead: boolean = false,
  featureFlags: { [key: string]: string } = {},
  request?: Pick<NextPageContext, 'req'>
): { isAmplienceContent: boolean; url: string } => {
  const { publicRuntimeConfig } = getConfig();
  const { appEnv } = publicRuntimeConfig;

  const parsedUrl = new URL(rawUrl, DEFAULT_FALLBACK_URL);
  const pathName = parsedUrl.pathname || '';
  const plainQueryString = parsedUrl.search.replace('?', '') || '';
  const parsedQueryString = parseQueryString(plainQueryString);
  const id = pathName && pathName !== '/' ? pathName : '/homepage';

  const pathWithoutTrailingSlash = pathName.endsWith('/')
    ? pathName.slice(0, -1)
    : pathName;

  let featureFlagParam = '';
  if (featureFlags && Object.keys(featureFlags).length !== 0) {
    const featureFlagsString = JSON.stringify(featureFlags);
    const parsedFeatureFlagsString = encodeURIComponent(featureFlagsString);
    featureFlagParam = `&featureFlags=${parsedFeatureFlagsString}`;
  }

  const cookies = parseCookies(request);

  const isAmplienceCookieIncluded = !!cookies['ampl'] || null;
  const isAmplienceContent =
    isAmplienceCookieIncluded ||
    featureFlagParam?.includes('isAmplienceContent') ||
    plainQueryString?.includes('isAmplienceContent');

  const appEnvParam = appEnv ? `&appEnv=${appEnv}` : '';

  if (isHead) {
    const { section } = parsedQueryString;
    const sectionParams = section ? `section=${section}&` : '';

    if (isAmplienceContent) {
      const isDev =
        plainQueryString?.includes('isDev=true') || cookies['ampl-dev'];
      const queryString = `isAmplienceContent=true${isDev ? '&isDev=true' : ''}`;

      const path =
        pathWithoutTrailingSlash === ''
          ? `/${CONTENT_BASE_PATH}/homepage.head?${queryString}`
          : `/${CONTENT_BASE_PATH}${pathWithoutTrailingSlash}.head?${sectionParams}includeMetadata=true&${queryString}`;

      return {
        isAmplienceContent,
        url: path,
      };
    }

    const path =
      pathWithoutTrailingSlash === ''
        ? `/${CONTENT_BASE_PATH}/homepage.head`
        : `/${CONTENT_BASE_PATH}${pathWithoutTrailingSlash}.head?${sectionParams}includeMetadata=true`;

    return {
      isAmplienceContent,
      url: path,
    };
  }

  const path = plainQueryString
    ? `/${CONTENT_BASE_PATH}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false&${plainQueryString}${featureFlagParam}${appEnvParam}`
    : `/${CONTENT_BASE_PATH}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false${featureFlagParam}${appEnvParam}`;

  return {
    isAmplienceContent,
    url: path,
  };
};

export default contentURLMapper;
